// Keep the Home and Contact heroes on the same video, poster and bounded loop.
export const MOROCCO_HERO_POSTER =
  "https://image.mux.com/HlwGpYi2dBcP007P3601vNiRiY9acrPyBB/thumbnail.jpg?width=1280&time=0";

export const MOROCCO_HERO_VIDEO = Object.freeze({
  videoId: "hVvEISFw9w0",
  endSeconds: 275,
  posterSrc: MOROCCO_HERO_POSTER,
});
